export const cookiesAgreed = () => {
  return {
    event: "cookiesAgreed",
  };
};
